import React from 'react';

import styles from './DrawerHeader.scss';

type Props = {
  ariaLabel?: string;
  children?: React.ReactNode;
};

function DrawerHeader(props: Props) {
  const { children, ariaLabel } = props;

  return (
    <header className={styles.header} aria-label={ariaLabel}>
      {children}
    </header>
  );
}

export default React.memo(DrawerHeader);
